import React from "react";
import Checkmark from '../assets/Checkmark.png'

const CheckMarkText = ({ label }) => {
    return (<div style={{ display: 'flex', flexDirection: 'row', marginTop: '10px', }}>
        <img src={Checkmark} style={{ width: '15px', height: '12px', marginRight: '4px', marginTop: '4px' }} />
        <label style={{ color: '#5E5E5E', fontSize: '16px' }}>{label}</label>

    </div>)
}

export default CheckMarkText